import { Injectable } from '@angular/core';
import { HandlerService } from '../../../core/handlers/handlers.service';
import { MethodsService } from '../../../core/http/method.service';
import { environment as params } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class OtherPagesService extends MethodsService {
    constructor(_HandlerService: HandlerService, http: HttpClient) {
        super(_HandlerService, http);
        this.setApi((<any>params).api.wp);
    }
    getDataOtherPage(page) {
        return this.get('/wp-json/page/other/' + page);
    }
}
